// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"765":"761a0c31","787":"9609f40d"}[chunkId] + ".chunk.js";
};